import ApiStatus from "../constants/api-status.enum";
import { OtpModalConstant } from "../constants/otp-modal.constant";
import { AppModalConstant } from "../constants/app-modal.constant";
import { AlertMessageModalConstant } from "../constants/alert-message.constant";

export default class OtpModalService {
    static disableButton(validateOtpApiStatus, validateOtpApiResponse, authLoginApiStatus, otpFormValidated) {
        if(validateOtpApiStatus === ApiStatus.LOADING || (validateOtpApiStatus === ApiStatus.SUCCESS && validateOtpApiResponse === AppModalConstant.SUCCESS_AIRTEL) ) {
            return true;
        }
        else if(authLoginApiStatus === ApiStatus.LOADING) {
            return true;
        }
        else {
            return this.checkFormValidation(otpFormValidated) ? false: true;
        }
    }

    static getButtonValue(validateOtpApiStatus, validateOtpApiResponse, authLoginApiStatus) {
        if(validateOtpApiStatus === ApiStatus.LOADING || (validateOtpApiStatus === ApiStatus.SUCCESS && validateOtpApiResponse === AppModalConstant.SUCCESS_AIRTEL) ) {
            return OtpModalConstant.VALIDATING_OTP;
        }
        else if(authLoginApiStatus === ApiStatus.LOADING) {
            return OtpModalConstant.VALIDATING_OTP;
        }
        else {
            return OtpModalConstant.VALIDATE_OTP;
        }
    }

    static checkFormValidation(otpFormValidated) {
        return otpFormValidated ? true : false;
    }

    static validateEnteredOtp(otp) {
        const regexForOnlyNumber = /^\d{4}$/;
        if (otp.match(regexForOnlyNumber)) {
            return true;
        }
        return false;
    }

    static getOtpErrorMessage = (validateOtpApiResponse) => {
        if(validateOtpApiResponse && validateOtpApiResponse.errorMessage){
            return validateOtpApiResponse.errorMessage
        }
        return AlertMessageModalConstant.INCORRECT_RESPONSE
    }
}